import { required } from 'vuelidate/lib/validators'
import { UFS } from '@/globals/staticVars.js'
const formData = {
  'name': {
    size: 12,
    type: 'text',
    name: 'name',
    label: 'Nome do consultório',
    placeholder: 'Digite o nome do consultório',
    value: null
  },
  'address.cep': {
    size: 8,
    type: 'text',
    name: 'address.cep',
    label: 'CEP',
    placeholder: 'Digite seu CEP',
    value: null,
    mask: '#####-###',
    hasSuccess: true,
    loading: 0
  },
  'address.city.name': {
    size: 4,
    type: 'text',
    name: 'address.city.name',
    label: 'Cidade',
    placeholder: '',
    value: null,
    disabled: true
  },
  'address.uf': {
    size: 2,
    type: 'select',
    name: 'address.uf',
    label: 'UF',
    options: UFS,
    placeholder: '',
    value: null,
    disabled: true
  },
  'address.district': {
    size: 6,
    type: 'text',
    name: 'address.district',
    label: 'Bairro',
    placeholder: '',
    value: null,
    disabled: false
  },
  'address.street': {
    size: 6,
    type: 'text',
    name: 'address.street',
    label: 'Endereço',
    placeholder: '',
    value: null,
    disabled: true
  },
  'address.number': {
    size: 3,
    type: 'text',
    name: 'address.number',
    label: 'Número',
    placeholder: '',
    value: null
  },
  'address.complement': {
    size: 3,
    type: 'text',
    name: 'address.complement',
    label: 'Complemento',
    placeholder: 'Ap., conj., etc',
    value: null
  },
  'address.latitude': {
    size: 2,
    type: 'hidden',
    hide: true,
    name: 'address.latitude',
    value: null
  },
  'address.longitude': {
    size: 2,
    type: 'hidden',
    hide: true,
    name: 'address.latitude',
    value: null
  }
}

const requiredFields = [
  'name',
  'address.cep',
  'address.city.name',
  'address.uf',
  'address.street',
  'address.number'
]
const validations = {}
for (let requiredField of requiredFields) {
  validations[requiredField] = {}
  validations[requiredField].value = {}
  validations[requiredField].value.required = required
}

// validations['address.cep'] = {
//   value: {
//     required,
//     validCep: function () { return this.validCep }
//   }
// }

export {
  formData, validations
}
